import { z } from 'zod';

export const teamSchema = z.object({
  id: z.number(),
  name: z.string(),
  slug: z.string({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    error: (issue) => ({
      message: 'The slug cannot be queried with this api token',
    }),
  }),
});
export const getTeamsReqDto = z.array(teamSchema);

export const getTeamsV2ResponseDto = z.object({
  status: z.string(),
  data: getTeamsReqDto,
});
